import React, { useContext, useMemo } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import FHeading1 from 'components/BaseComponents/Text/FHeading1'

import { FParagraphGroup } from 'components/BaseComponents/Text'
import FImage from 'components/BaseComponents/FImage'
import { StepWizardChildProps } from 'react-step-wizard'
import { useRouter } from 'next/router'
import { OrganizationContext } from 'v2/context/organization'
import { ApplicationContext } from 'v2/context/application'

interface Props {
    onFinish?: () => void
}

const ThankYouPage: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    props.onFinish()
    return null

    return <div />
}

export default ThankYouPage
